import { makeAutoObservable } from "mobx"

export default class Influencer {

  constructor(influencer={}) {
    this.id = influencer.id
    this.full_name = influencer.full_name || ''
    this.email = influencer.email || ''
    this.youtube_username = influencer.youtube_username || ''
    this.linkedin_username = influencer.linkedin_username || ''
    this.authentications = influencer.authentications || []
    makeAutoObservable(this)
  }
}
